// Modules
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import { CommonModule } from '@angular/common';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import * as i0 from "@angular/core";
export class SingleDatePickerModule {
}
SingleDatePickerModule.ɵfac = function SingleDatePickerModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SingleDatePickerModule)(); };
SingleDatePickerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleDatePickerModule });
SingleDatePickerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule, CommonModule, DisabledModule, FormsModule, SingleSelectDropdownModule] });
